import module from 'cliente/module.js'

const schema = {
  Descuento: 'number',
  IVA: 'number',
  Subtotal: 'number',
  Total: 'number',
  Fecha: 'date',
  CFDI: 'boolean',
  id_nomina: 'array',
}

export class ClienteFacturasFacturaService {
  constructor ($http, $api) {
    this.$http = $http
    this.$api = $api
  }

  get (idCliente, rfcEmpresa, folio, serie) {
    return this.$http.get('/kendu/clientes/cliente/facturas/factura', {
      params: {
        idCliente: idCliente,
        rfcEmpresa: rfcEmpresa,
        folio: folio,
        serie: serie,
      },
      cache: 'Cliente',
      schema,
    })
  }

  generarCFDI (idCliente, rfcEmpresa, folio, id_comprobante, formato) {
    return this.$api.open('kendu/clientes/cliente/facturas/factura/documentos/cfdi', {
      idCliente: idCliente,
      rfcEmpresa: rfcEmpresa,
      folio: folio,
      id_comprobante: id_comprobante,
      formato: formato,
    })
  }
}

module.service('ClienteFacturasFactura', ClienteFacturasFacturaService)



// WEBPACK FOOTER //
// ./src/cliente/services/Facturas/Factura.js